import api from './api';

export const SpecializedPatientsAPI = {
  getAllPatientBookings: (params = {}) => api.get('/api/v1/bookings', { params }),
};